import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({ providedIn: 'root' })
export class DividendsService {

  constructor(private jsonObjectFactory: JsonObjectFactoryService) {}

  getDividendTypes(baseUrl: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.jsonObjectFactory.getJSONObj6(url, { action_code: 'zzi5c3' }, globalService, filterParams);
  }

  getTransCurrencies(baseUrl: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.jsonObjectFactory.getJSONObj6(url, { action_code: '3ucwjb' }, globalService, filterParams);
  }

  getDividendsPaid(baseUrl: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.jsonObjectFactory.getJSONObj6(url, { action_code: '9p9a6f' }, globalService, filterParams);
  }

  getDividendsReceived(baseUrl: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.jsonObjectFactory.getJSONObj6(url, { action_code: 'lw4c62' }, globalService, filterParams);
  }

  getEntities(baseUrl: string, taxYear: any, scenario: any, jcdKey: any, searchValue: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'umt3zd',
      tax_year: taxYear,
      scenario: scenario,
      jcd_key: jcdKey,
      search_string: searchValue
    };
    return this.jsonObjectFactory.getJSONObj6(url, params, globalService, filterParams);
  }

  getPayeeEntities(baseUrl: string, taxYear: any, scenario: any, jcdKey: any, searchValue: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: '7bkc4j',
      tax_year: taxYear,
      scenario: scenario,
      jcd_key: jcdKey,
      search_string: searchValue
    };
    return this.jsonObjectFactory.getJSONObj6(url, params, globalService, filterParams);
  }

  get304Entities(baseUrl: string, taxYear: any, scenario: any, jcdKey: any, searchValue: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'vrtuvn',
      tax_year: taxYear,
      scenario: scenario,
      jcd_key: jcdKey,
      search_string: searchValue
    };
    return this.jsonObjectFactory.getJSONObj6(url, params, globalService, filterParams);
  }

  getEntityFeeds(baseUrl: string, tpKey: any, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: '8q0a79',
      tp_key: tpKey === null || tpKey === undefined ? 389124 : tpKey
    };
    return this.jsonObjectFactory.getJSONObj6(url, params, globalService, filterParams);
  }

  getPayeeEntityFeeds(baseUrl: string, tpKey: any, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'e884ud',
      tp_key: tpKey === null || tpKey === undefined ? 389124 : tpKey
    };
    return this.jsonObjectFactory.getJSONObj6(url, params, globalService, filterParams);
  }

  getTransId(baseUrl: string, taxYear: any, searchValue: string, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'tf5pes',
      tax_year: taxYear,
      search_string: searchValue
    };
    return this.jsonObjectFactory.getJSONObj6(url, params, globalService, filterParams);
  }

  saveUpdateDividends(
    baseUrl: string,
    jsonObj: any,
    jsonSettings: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=tg6bvf`;
    const globalParams = globalService?.globalParams || globalService || {};
    let params: any = _.merge({}, globalParams, filterParams || {});
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'DIVIDENDS';

    const checkLockedbj = [{ combination_key: rowData?.COMBINATION_KEY ?? '' }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    return this.jsonObjectFactory.saveJSON6(url, params, globalService, filterParams);
  }

  deleteDividends(baseUrl: string, payload: any, globalService: any, filterParams: any ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=t0d7co`;
    const globalParams = globalService?.globalParams || globalService || {};
    const params: any = _.merge({}, payload || {}, globalParams, filterParams || {});
    return this.jsonObjectFactory.saveJSON6(url, params, globalService, filterParams);
  }
}
